export default "__VITE_ASSET__480606c1__"